/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ZugangDto } from '../../models/zugang-dto';

export interface GetAllZugaenge$Plain$Params {
}

export function getAllZugaenge$Plain(http: HttpClient, rootUrl: string, params?: GetAllZugaenge$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ZugangDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllZugaenge$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ZugangDto>>;
    })
  );
}

getAllZugaenge$Plain.PATH = '/v1/zugaenge';
